import React, { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import { useStaticQuery, graphql } from 'gatsby'

const useStyles = makeStyles(theme => ({
  sidebarSection: {
    marginTop: theme.spacing(3),
  },
}))

interface dataQuery {
  allMdx: {
    nodes: {
      monthAndYear: string
    }[]
  }
}

export const PureSidebar = (data: dataQuery): JSX.Element => {
  const classes = useStyles()
  const monthAndYears = [...new Set(data.allMdx.nodes.map(x => x.monthAndYear))]
  return (
    <Grid item xs={12} md={4}>
      <Typography variant="h6" gutterBottom className={classes.sidebarSection}>
        Archives
      </Typography>
      {monthAndYears.map(archive => (
        <Link
          display="block"
          variant="body1"
          href={`/blog/${archive.replace(/\s+/g, '-')}`}
          key={archive}
        >
          {archive}
        </Link>
      ))}
    </Grid>
  )
}

const Sidebar: FC = () => {
  /* istanbul ignore next */
  const data: dataQuery = useStaticQuery(graphql`
    query {
      allMdx(sort: { fields: frontmatter___date, order: DESC }) {
        nodes {
          monthAndYear
        }
      }
    }
  `)

  /* istanbul ignore next */
  return <PureSidebar {...data} />
}

export default Sidebar
